import { render } from "./SavingCalculator.vue?vue&type=template&id=3882dd76&scoped=true"
import script from "./SavingCalculator.vue?vue&type=script&lang=js"
export * from "./SavingCalculator.vue?vue&type=script&lang=js"

import "./SavingCalculator.vue?vue&type=style&index=0&id=3882dd76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3882dd76"]])

export default __exports__